import { PERPETUAL } from '@/constants/durations'

class PricingPanelVariant {
  constructor({
    id,
    isOnlineResource,
    isOnlineResourceBundle,
    isPrint,
    localePrice,
    selectedVariantId,
    variant,
    translations
  }) {
    const {
      print_variant_marketplace,
      print_variant_new,
      print_variant_rental,
      print_variant_used,
      purchase_buy_etextbook,
      purchase_license_item
    } = translations

    const { duration } = variant

    const isSelected = id === selectedVariantId

    const isPerpetual = duration === PERPETUAL

    const isOnlineResourceOrBundle = isOnlineResource || isOnlineResourceBundle

    const conditionMap = {
      marketplace: print_variant_marketplace,
      new: print_variant_new,
      used: print_variant_used,
    }

    const printVariantDescription = variant => {
      if (variant.orderType === "rental") {
        return print_variant_rental
      } else {
        return conditionMap[variant.condition]
      }
    }

    const durationExpirationText = () => {
      if (isPrint) {
        return printVariantDescription(variant)
      }
      else if (isPerpetual) {
        if(isOnlineResourceOrBundle) {
          return purchase_license_item
        } else {
          return purchase_buy_etextbook
        }
      }
      else {
        return duration
      }
    }

    this.id = id,
    this.studentPrice = localePrice.formattedAmount
    this.durationExpirationText = durationExpirationText()
    this.className = `variant${isSelected ? ' selected' : ''}`,
    this.fullVariant = variant
    this.isSelected = isSelected
  }
}

export default PricingPanelVariant
